export const IS_ONLINE_TOAST_ID = 'toast-is-online'
export const IS_OFFLINE_TOAST_ID = 'toast-is-offline'
